
import AutoplayModel from "slotworks/model/autoplay-model";
import SmartButton from "slotworks/smart-button/smart-button";
import State from "slotworks/state-machine/states/state";
import Timer from "slotworks/utils/timer";

export default class Autoplay extends State {

    public static WAIT: number = 0;

    private waitTimer: number;

    public onEnter() {
        AutoplayModel.decrease();
        SmartButton.refresh();

        if (Autoplay.WAIT > 0) {
            this.waitTimer = Timer.setTimeout(() => this.complete(), Autoplay.WAIT);
        } else {
            this.complete();
        }
    }

    public onSkip() {
        Timer.clearTimeout(this.waitTimer);

        this.skip();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/state-machine/standard/states/autoplay.ts